import yup from '@/utils/yup-extended'

export interface RegisterPhoneModel {
  phone: string
}

export interface RegisterEmailModel {
  email: string
}

export interface RegisterCodeEmailModel {
  email_code: string
}

export interface RegisterCodePhoneModel {
  phone_code: string
}

export interface RegisterPoliciesModel {
  conditions: boolean
  concept: boolean
  policy: boolean
}

export interface RegisterFinishModel {
  confirm: boolean
}

export interface RegisterCheckPoliciesModel {
  agree: number
  token: string
}

export interface RegisterCodeModel {
  code: string
  token: string
}

export interface RegisterPhoneModel {
  phone: string
  token: string
}

export interface RegisterFinishRequestModel {
  token: string
}

export type RegisterFormData = RegisterPhoneModel &
  RegisterEmailModel &
  RegisterPoliciesModel &
  RegisterCodeEmailModel &
  RegisterCodePhoneModel &
  RegisterFinishModel & {
    type: 'person' | 'company'
    token?: string
  } & RegisterCheckPoliciesModel

export interface RegisterResponse {
  step: 'check_policies' | 'email_verify'
  token: string
}

export interface RegisterStep {
  component: JSX.Element
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  schema: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValues: Record<string, any>
}

export const RegisterValidationPhoneSchema = yup.object().shape({
  phone: yup
    .string()
    .required()
    .matches(/^\+?\d{10,15}$/, 'Phone number is not valid'),
})

export const RegisterValidationEmailSchema = yup.object().shape({
  email: yup.string().required().email('Email is not valid'),
})

export const RegisterValidationCodeEmailSchema = yup.object().shape({
  email_code: yup.string().required(),
})

export const RegisterValidationCodePhoneSchema = yup.object().shape({
  phone_code: yup.string().required(),
})

export const RegisterValidationPoliciesSchema = yup.object().shape({
  conditions: yup.boolean().oneOf([true], 'You must check this box to proceed'),
  concept: yup.boolean().oneOf([true], 'You must check this box to proceed'),
  policy: yup.boolean().oneOf([true], 'You must check this box to proceed'),
})

export const RegisterValidationFinishSchema = yup.object().shape({
  confirm: yup.boolean().oneOf([true], 'You must check this box to proceed'),
})
